import { savedTeamsApi } from '../api/endpoints.ts';

/** Refresh revisions before each attempt. Retrying never recreates an account. */
export async function addEmployeesToTeams(
  employeeIds: string[],
  teamIds: string[],
  assertScope: () => void = () => {},
) {
  assertScope();
  const fresh = await savedTeamsApi.list();
  for (const teamId of teamIds) {
    assertScope();
    const team = fresh.items.find((entry) => entry.id === teamId && entry.isActive);
    if (!team) throw new Error('teamUnavailable');
    const memberIds = [...new Set([...team.memberIds, ...employeeIds])];
    if (memberIds.length > 20) throw new Error('teamFull');
    if (memberIds.length !== team.memberIds.length) {
      await savedTeamsApi.update(team.id, { memberIds, expectedRevision: team.revision, updateFutureVisits: false });
    }
  }
}
